import React from 'react';
import constate from 'constate';
import { usePostNotifications } from '../pages/Posts/usePostNotifications';

const [provider, hook] = constate(usePostNotifications);

export const NotificationProvider = provider;

export const useNotificationContext = hook;

export const withNotificationProvider = Component => props => {
    return (
        <NotificationProvider>
            <Component {...props} />
        </NotificationProvider>
    );
};
